import type { ButtonHTMLAttributes } from "react";

// The Button thin wrapper maps logical variants onto the portal design-system
// pill classes defined in `index.css`. The full-size pills (`primary`,
// `ghost`) are intended for hero CTAs; the compact `-sm` variants are for
// inline action rows inside tables and cards.
//
// Historical names `secondary` and `danger` are kept for backward compat:
//   - `secondary` aliases `ghost`
//   - `danger`    aliases `danger-sm` (the only destructive style we have)
type Variant =
  | "primary"
  | "ghost"
  | "secondary"
  | "primary-sm"
  | "ghost-sm"
  | "secondary-sm"
  | "danger"
  | "danger-sm";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
};

const variantClasses: Record<Variant, string> = {
  primary: "btn-primary",
  ghost: "btn-ghost",
  secondary: "btn-ghost",
  "primary-sm": "btn-primary-sm",
  "ghost-sm": "btn-ghost-sm",
  "secondary-sm": "btn-ghost-sm",
  danger: "btn-danger-sm",
  "danger-sm": "btn-danger-sm",
};

export function Button({
  variant = "primary",
  className = "",
  type = "button",
  ...rest
}: Props) {
  return (
    <button
      type={type}
      className={`${variantClasses[variant]} ${className}`.trim()}
      {...rest}
    />
  );
}
